// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bc-0";
export var orangeButton = "_bc-1";